
var getDevice = (function(){
    var ua = navigator.userAgent;
    if(ua.indexOf('iPad') > 0){
      return 'ipad';
    }else{
      return 'other';
    }
})();

var $s4Hero = document.querySelector(".s4-Hero");

if( getDevice == 'ipad' ){

  if($s4Hero) {
    $s4Hero.style.backgroundSize = '260% auto';
  }
}

